module.exports = "<div class=\"mask-confirm\"></div>\n<div class=\"confirm\" [ngStyle]=\"{display: display}\" [ngClass]=\"class\">\n    <div class=\"confirm-switch\">\n        <p [textContent]=\"message\"></p>\n        <div class=\"confirm-fon\">\n            <button (click)=\"Confirm()\">Yes</button>\n            <button (click)=\"Cancel()\">No</button>\n        </div>\n    </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/confirm/html/confirm.component.html
// module id = ./src/app/components/confirm/html/confirm.component.html
// module chunks = main